import { Header } from "../components/landing/Header";
import { HeroSection } from "../components/landing/HeroSection";
import { StatsSection } from "../components/landing/StatsSection";
import { FeaturesSection } from "../components/landing/FeaturesSection";
import { BenefitsSection } from "../components/landing/BenefitsSection";
import { AlabanzasSection } from "../components/landing/AlabanzasSection";
import { PlatformsSection } from "../components/landing/PlatformsSection";
import { CTASection } from "../components/landing/CTASection";
import { Footer } from "../components/landing/Footer";
import { Toaster } from "sonner";

export default function LandingPage() {
  return (
    <div className="min-h-screen">
      <Toaster position="top-right" richColors />
      <Header />
      <HeroSection />
      <StatsSection />
      <FeaturesSection />
      <BenefitsSection />
      <AlabanzasSection />
      <PlatformsSection />
      <CTASection />
      <Footer />
    </div>
  );
}
